import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../style/Work.css";

const panelVariants = {
    hidden: { x: "100%" },
    visible: { x: 0 },
    exit: { x: "100%" },
};

const contentVariants = {
    hidden: { opacity: 0, y: 16 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -10 },
};

const SideMenu = ({ category }) => {
    const [activeVideo, setActiveVideo] = useState(null);

    return (
        <motion.div
            className="side-menu"
            variants={panelVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            transition={{ duration: 0.65, ease: [0.32, 0.72, 0, 1] }}
        >
            {/* The panel stays put while switching categories; only its content crossfades. */}
            <AnimatePresence mode="wait">
                <motion.div
                    key={category.name}
                    className="side-menu-content"
                    variants={contentVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    transition={{ duration: 0.25, ease: "easeOut" }}
                >
                    {category.artists.map((artist, artistIndex) => (
                        <div key={artistIndex} className="artist-section">
                            <div className="video-grid">
                                {artist.videos.map((videoId, videoIndex) => (
                                    <div
                                        key={videoIndex}
                                        className="video-wrapper"
                                        onClick={() => setActiveVideo(videoId)}
                                    >
                                        {activeVideo === videoId ? (
                                            <iframe
                                                className="video-embed"
                                                src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&showinfo=0&enablejsapi=1&autoplay=1`}
                                                title={`YouTube Video ${videoIndex + 1}`}
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                allowFullScreen
                                            ></iframe>
                                        ) : (
                                            <div className="thumbnail-container">
                                                <img
                                                    className="video-thumbnail grayscale"
                                                    src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                                                    alt={`Video ${videoIndex + 1}`}
                                                    loading="lazy"
                                                />
                                                <div className="artist-name-overlay">
                                                    {artist.name}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </motion.div>
            </AnimatePresence>
        </motion.div>
    );
};

export default SideMenu;
